import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ServiceModule} from '../../../service.module';
import {CONFIG_FALLBACK} from "./config-fallback";
import {Utils} from "../../../../core/helpers/Utils";

@Injectable({providedIn: 'root'})
export class FrontendConfigService {
    private readonly CONFIG_URL = '/config/config.json';
    _config: any;

    constructor(private _httpClient: HttpClient) {}

    async load() {
        return this.getConfig().then((res) => {
            this._config = res;
            return res;
        }).catch((err) => {
            this._config = CONFIG_FALLBACK;
        }).finally(() => {
            Utils.setPrivateCloud(this._config?.privateCloud);
            Utils.setSpfiEndpoint(this._config?.spfiEndpoint);
            Utils.setHideOpscurity(this._config?.hideOpscurity);
            Utils.setAiAssistant(this._config?.aiAssistant?.enabled);
        });
    }

    async getConfig(): Promise<any> {
        this._config = await firstValueFrom(this._httpClient.get<any>(this.CONFIG_URL));
        return this._config;
    }

    getFrontendConfigModel() {
        if (!this._config) {
            return CONFIG_FALLBACK;
        }
        return this._config;
    }

}
